import {
  Components, ColorProfiles,
} from '@powdr/constants';

// Color Profiles
const {
  BASE, PRIMARY, SECONDARY, TERTIARY, QUATERNARY,
} = ColorProfiles;

export const config = {
  [Components.HEADER]: BASE,
  [Components.MAIN_NAV]: BASE,
  [Components.MEGA_NAV]: BASE,
  [Components.MOBILE_NAV]: BASE,
  [Components.ECOMMERCE_BANNER]: SECONDARY,
  [Components.WEATHER_FEED]: QUATERNARY,
  [Components.PROMOTIONS_FEED]: PRIMARY,
  [Components.PROMOTIONS]: PRIMARY,
  [Components.ALERT_BAR]: SECONDARY,
  [Components.STICKY_NAV]: PRIMARY,
  [Components.TERTIARY_NAV]: BASE,
  [Components.LEVELS_MODAL]: BASE,
  [Components.FOOTER]: SECONDARY,
  [Components.FOOTER_NAV]: SECONDARY,
  [Components.PARTNERS]: SECONDARY,
  [Components.COPYRIGHT]: SECONDARY,
  [Components.MODAL]: BASE,
  [Components.TV]: BASE,
  [Components.DOR]: BASE,
  layout: {
    headerHeight: 90,
    headerHeightMobile: 60,
    headerLogoContainerWidth: 275,
    headerLogoHeight: 60,
    headerFeedContainer: 250,
  },
};
